var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{attrs:{"value":_vm.localValue,"label":_vm.label,"shortTitle":_vm.shortTitle,"options":_vm.options,"v":_vm.v,"required":_vm.required,"help":_vm.help},on:{"input":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }